import { createAction } from "@ngrx/store";

/**
 * Create the action to reset the store back to its init state.
 */
export const clearRootState = createAction("[Root Store Management] Clear Root Store");
